import React from 'react';
import { Button } from './Button';
import { ClientProof } from './ClientProof';
import { Dial } from './Dial';
type ReadingCTAProps = {
  title?: string;
  body?: string;
  to?: string;
  proofIndex?: number;
};
export function ReadingCTA({
  title = 'Pair it with a Birth Chart Reading',
  body = 'A one-hour session with Abby, by phone or video, after she has spent about an hour studying your chart.',
  to = '/readings?type=birth-chart#book',
  proofIndex = 0
}: ReadingCTAProps) {
  return <aside className="grid items-center gap-10 bg-cream p-[clamp(1.75rem,4vw,5rem)] md:grid-cols-[auto_minmax(0,1fr)_minmax(0,0.9fr)]" data-id="element-393" data-mp="ozz1az3llwto">
      <Dial numerals="twelve" star={false} className="hidden h-[clamp(5rem,8vw,9rem)] w-[clamp(5rem,8vw,9rem)] md:block" data-id="element-394" data-mp="12yf9yvl0txeg" />
      <div data-id="element-395" data-mp="yviw1i6fepgu">
        <p className="t-h3" data-id="element-396" data-mp="34qbvmy0wknmy">{title}</p>
        <p className="mt-3 max-w-[50ch] text-graphite" data-id="element-397" data-mp="34rd4cvug4y1i">{body}</p>
        <Button to={to} className="mt-7" data-id="element-398" data-mp="30ozze9nix45s">
          Book a Reading · $200
        </Button>
      </div>
      <ClientProof index={proofIndex} data-id="element-399" data-mp="tz61thw8wlnr" />
    </aside>;
}